import React, { useEffect, useState } from 'react';
import Markdown from 'markdown-to-jsx';
import axios, { AxiosResponse } from 'axios';
import useQueryParam from '@src/shared/hooks/use-queryparam';
import { languageQueryParam } from '@src/i18n';
import useStyles from './styles';
export const JetCourierCookieStatement = () => {
  const [content, setContent] = useState('');
  const { params } = useQueryParam(languageQueryParam);
  const defaultLang = 'en';
  const existingPrivacyStatementLanguagesList = ['en', 'pl'];
  const classes = useStyles();

  useEffect(() => {
    if (params) {
      const privacyFileLanguage = existingPrivacyStatementLanguagesList.includes(params)
        ? params
        : defaultLang;
      axios
        .get(
          `/jetcourier_cookie_statement_docs/jetcourier_cookie_statement_${privacyFileLanguage}.md`
        )
        .then((response: AxiosResponse) => {
          setContent(response.data);
        });
    } else {
      axios
        .get(`/jetcourier_cookie_statement_docs/jetcourier_cookie_statement_${defaultLang}.md`)
        .then((response: AxiosResponse) => {
          setContent(response.data);
        });
    }
  }, [params]);
  return (
    <>
      <div className={classes.cookieStatementContainer}>
        <Markdown>{content}</Markdown>
      </div>
    </>
  );
};
export default JetCourierCookieStatement;

//max-width: 1280px; min-height: calc(100% - 13vh);
